import React from 'react';

import SectionMessage from '@atlaskit/section-message';
import { useSession } from 'src/services/pagerduty/session';

import { getEnvironment } from 'src/lib/featureFlags';

import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';

import CreateIssueForm from './CreateIssueForm';

const CreateIssueModalImpl = () => {
  const { loggedIn, loading, error } = useSession();

  const ModalContent = () => {
    if (loading) {
      return <CenteredSpinner size="large" />;
    }
    if (loggedIn) {
      return <CreateIssueForm />;
    }

    return <ErrorMessage error={['Authorization failed', error || 'Unknown error']} />;
  };

  return (
    <div style={{ padding: 15 }}>
      <ModalContent />
    </div>
  );
};

const CreateIssueModal = () => {
  if (getEnvironment().isSilentOauthSupported) {
    return <CreateIssueModalImpl/>;
  } else {
    return (
      <SectionMessage appearance={'info'}>
        Manual issue creation is not supported.
        <br/>
        This is temporary limitation in European accounts.
      </SectionMessage>
    );
  }
};

export default CreateIssueModal;
